const STORAGE_KEY = 'senviro.cmd-palette.recent';
const MAX_RECENT = 5;

/**
 * Persists the last-N invoked action IDs to localStorage so the palette can
 * surface a "Recent" group on next open. Defensive against SSR + private
 * browsing where localStorage may throw.
 */
export function getRecentActionIds(): string[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((entry): entry is string => typeof entry === 'string');
  } catch {
    return [];
  }
}

export function pushRecentActionId(id: string): void {
  if (typeof window === 'undefined') return;
  try {
    const current = getRecentActionIds().filter((entry) => entry !== id);
    const next = [id, ...current].slice(0, MAX_RECENT);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // localStorage unavailable — silently no-op.
  }
}
